import { myLayoutActions } from ".";

export const handleNotify = (isNotify, message) => {
  return async (dispatch) => {
    dispatch(myLayoutActions.setIsNotify(isNotify));
    dispatch(myLayoutActions.setNotificationMsg(message));
  };
};

export const handleMenu = (isOpen) => {
  return async (dispatch) => {
    dispatch(myLayoutActions.setIsMenuOpen(isOpen));
  };
};

export const handleFilter = (action, filter) => {
  return async (dispatch) => {
    dispatch(myLayoutActions.setIsMenuOpen(false));
    switch (action) {
      case "category":
        dispatch(myLayoutActions.setFilterByCategory(filter));
        break;
      case "org":
        dispatch(myLayoutActions.setFilterByOrganisation(filter));
        break;
      case "search":
        dispatch(myLayoutActions.setFilterBySearch(filter));
        break;
      case "date":
        dispatch(myLayoutActions.setFilterByDate(filter));
        break;
      case "reset":
        dispatch(myLayoutActions.setFilterByCategory(null));
        dispatch(myLayoutActions.setFilterByOrganisation(null));
        dispatch(myLayoutActions.setFilterBySearch(null));
        dispatch(myLayoutActions.setFilterByDate(null));
        break;
      default:
        console.warn(`Unknown action: ${action}`);
    }
  };
};
